import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Grid, Paper, Box, Typography, List, useTheme } from "@mui/material";
import NewsSectionCard from "./news-section-card";

import { Article } from '@mui/icons-material';

import NewsSectionCardListHeader from './news-section-card-list-header';
import CustomIcon from 'src/components/custom-icon';

export default function NewsSectionMainContent({ articles, sectionInfo, clientportal, props }) {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const accentColor = clientportal && clientportal.defaultcolor ? clientportal.defaultcolor : primaryColor

  return (
    <Grid item xs={12} sm={11} md={10} lg={8} xl={7}>
      {/* Container principal com sombra elegante */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#fff',
          borderRadius: { xs: '12px', md: '16px' },
          overflow: 'hidden',
          border: '1px solid #f0f0f0',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
        }}
      >
        {/* Header da seção com gradiente sutil */}
        <NewsSectionCardListHeader
          sectionInfo={sectionInfo}
          clientportal={clientportal}
          articles={articles}
        />

        {/* Lista de artigos */}
        <Box sx={{ px: { xs: 0, sm: 1 }, py: { xs: 1, sm: 2 } }}>
          {articles.length > 0 ? (
            <List disablePadding>
              {articles.map((article, index) => (
                <NewsSectionCard
                  key={article.id}
                  article={article}
                  index={index}
                  articles={articles}
                  clientportal={clientportal}
                  props={props}
                />
              ))}
            </List>
          ) : (
            // Mensagem elegante para quando não há notícias
            <Box sx={{
              py: { xs: 6, md: 8 },
              px: 3,
              textAlign: 'center'
            }}>
              <Box sx={{
                width: 80,
                height: 80,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
              }}>
                <CustomIcon icon={Article} color={accentColor} iconSx={{ fontSize: 36 }} />
              </Box>

              <Typography
                variant="h6"
                color="text.secondary"
                sx={{
                  fontWeight: 500,
                }}
              >
                <FormattedMessage id="No.news.found" />
              </Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Grid>
  )
}